import AudioPlayer from '@/components/custom-components/AudioPlayer/AudioPlayer'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useLocalStorage } from 'usehooks-ts'

export const Route = createFileRoute('/popout-audio')({
  component: PopoutAudio,
})

function PopoutAudio() {
  const [, setIsPopoutOpen] = useLocalStorage<boolean>('audioPopoutOpen', false)

  useEffect(() => {
    const unloadHandler = () => {
      setIsPopoutOpen(false)
    }
    window.addEventListener('beforeunload', unloadHandler)
    return () => {
      window.removeEventListener('beforeunload', unloadHandler)
    }
  }, [setIsPopoutOpen])

  return (
    <div className="p-2 bg-white">
      <AudioPlayer isPopout />
    </div>
  )
}

export default PopoutAudio
